namespace GeniuzPOS.Purchase {
    export namespace PoSupplierService {
        export const baseUrl = 'Purchase/PoSupplier';

        export declare function Create(request: Serenity.SaveRequest<PoSupplierRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PoSupplierRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PoSupplierRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PoSupplierRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/PoSupplier/Create",
            Update = "Purchase/PoSupplier/Update",
            Retrieve = "Purchase/PoSupplier/Retrieve",
            List = "Purchase/PoSupplier/List"
        }

        [
            'Create', 
            'Update', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PoSupplierService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
